import React from 'react'
import ClosureApproveRequest from './ClosureApproveRequest'
import { ASSET_CLOSURE_STEP } from '../../../constants/assetClosureStep'

export function ClosureApproveRequestStep1() {
  return <ClosureApproveRequest step={ASSET_CLOSURE_STEP.REQUEST_STEP_1} />
}

export function ClosureApproveApproveStep1() {
  return <ClosureApproveRequest step={ASSET_CLOSURE_STEP.APPROVE_STEP_1} />
}

export function ClosureApproveRequestStep2() {
  return <ClosureApproveRequest step={ASSET_CLOSURE_STEP.REQUEST_STEP_2} />
}

export function ClosureApproveApproveStep2() {
  return <ClosureApproveRequest step={ASSET_CLOSURE_STEP.APPROVE_STEP_2} />
}
